import { useContext, useState, useEffect } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "../../Components/Select";
import { Link } from "react-router-dom";
import axios from "axios";
export default function EnhMunavebeUygula() {
 
  const {
    API_URL,
    user,
    munavebeler,
    setMunavebeler,
    kapitalizasyonFaizOrani,
    setOrtNetGelir,
    setMunUrunSayisi,
    setTopNetGelir,
    munavebeAdi,
    setMunavebeAdi,
    gelenListe,
    setGelenListe,
    masrafUcteBirMi,
    setMasrafUcteBirMi,
    tasinmazm2fiyati,
    setTasinmazM2Fiyati,
  } = useContext(GlobalContext);

  const [munavebeUrunSayisi, setMunavebeUrunSayisi] = useState(0);

  const handleMasrafUcteBir = () => {
    setMasrafUcteBirMi(true);
    masrafDurumunaGoreDegerle();
  };

  const handleMasrafResmiVeri = () => {
    setMasrafUcteBirMi(false);
    masrafDurumunaGoreDegerle();
  };

  const dbdenMunavebeAl = (user) => {
    try {
      axios
        .post(API_URL + "/munavebegetir", { user })
        .then((response) => {
          console.log("object :>> ", response);
          setMunavebeler(response.data);
        })
        .catch((error) => {
          alert("Bir Sorun var");
          console.error("There was an error!", error.data);
        });
    } catch (error) {}
  };

  useEffect(() => {
    munavebeler.length<1&&dbdenMunavebeAl(user);
    masrafDurumunaGoreDegerle();
    const onBeforeUnload = () => {
      masrafDurumunaGoreDegerle();
    };

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [masrafUcteBirMi]);

  const masrafDurumunaGoreDegerle = () => {
    try {
      setOrtNetGelir(0);
      setTopNetGelir(0);
      setMunavebeUrunSayisi(0);
      setGelenListe(false);

      let kullanilacakMunavebe = munavebeler.filter((munavebe) => {
        return munavebe.name === munavebeAdi;
      });

      if (kullanilacakMunavebe.length === 0) {
        alert("Listeden Münavebe Seçiniz.");
        return;
      }

      const liste = JSON.parse(kullanilacakMunavebe[0].data);

      setGelenListe(liste);
      setMunavebeUrunSayisi(liste.length);
      setMunUrunSayisi(liste.length);

      if (!kapitalizasyonFaizOrani || kapitalizasyonFaizOrani === 0) {
        alert("Kapitalizasyon faiz oranı geçerli bir değer değil!");
        return;
      }

      if (!liste || liste.length === 0) {
        alert("Geçerli bir liste seçiniz!");
        return;
      }

      let tng = 0;
      let ong = 0;

      if (masrafUcteBirMi) {
        liste.forEach((veriler) => {
          tng +=
            parseFloat(veriler.anaUrunFiyat || 0) *
              parseFloat(veriler.anaUrunVerim || 0) +
            parseFloat(veriler.yanUrunGelir || 0) -
            (parseFloat(veriler.anaUrunFiyat || 0) *
              parseFloat(veriler.anaUrunVerim || 0) +
              parseFloat(veriler.yanUrunGelir || 0)) /
              3;
        });
      }

      if (!masrafUcteBirMi) {
        liste.forEach((veriler) => {
          tng +=
            parseFloat(veriler.anaUrunFiyat || 0) *
              parseFloat(veriler.anaUrunVerim || 0) +
            parseFloat(veriler.yanUrunGelir || 0) -
            parseFloat(veriler.masraf || 0);
        });
      }

      ong = parseFloat(tng) / parseFloat(munavebeUrunSayisi);
      const tmf = ong / kapitalizasyonFaizOrani / 1000;

      setTasinmazM2Fiyati(tmf);
      setTopNetGelir(tng);
      setOrtNetGelir(ong);

      console.log("Toplam Net Gelir", tng);
      console.log("Ortalama Net Gelir", ong);
      console.log("liste.length :>> ", liste.length);
      console.log("tmf :>> ", tmf);
    } catch (error) {
      console.error(error);
      alert("Bir hata oluştu. Lütfen tekrar deneyiniz.");
    }
  };

  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center">Münavebe ve Değerleme </h1>
        </div>
        <div className="row my-2">
          <h3>Münavebe Ürünleri</h3>
        </div>
        <div className="row my-2">
          <div className="col-3"></div>
        </div>
        <div className="row my-2">
          <div className="col-3">
            <Select
              liste={munavebeler}
              mesaj="Kayıtlı Münavebe Seçiniz"
              Change={setMunavebeAdi}
              value={munavebeAdi}
            ></Select>
          </div>

          <div className="col-5">
            <div className="row">
              <div className="col">
                <div className="form-check">
                  <input
                    className="form-check-input "
                    type="radio"
                    name="masraforani"
                    id="uctebir"
                    checked={masrafUcteBirMi === true ? true : false}
                    onChange={() => handleMasrafUcteBir()}
                  />
                  <label
                    className="form-check-label text-danger"
                    htmlFor="uctebir"
                  >
                    Masraf Değerleri <b>Brüt Gelirin 1/3'ü</b> alınsın.
                  </label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="masraforani"
                    id="resmiveri"
                    checked={masrafUcteBirMi === false ? true : false}
                    onChange={() => handleMasrafResmiVeri()}
                  />
                  <label className="form-check-label" htmlFor="resmiveri">
                    Masraf Değerleri <b>Resmi Veriler</b> alınsın.
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-3">
            <button
              className="btn btn-primary btn-lg"
              onClick={masrafDurumunaGoreDegerle}
            >
              Münavebeyi Uygula
            </button>

            <h2
              className="mt-5"
              style={{ color: tasinmazm2fiyati === Infinity ? "red" : "blue" }}
            >
              m2 Fiyatı: {tasinmazm2fiyati.toFixed(2)} TL olarak hesaplanır.
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="row">
            {munavebeAdi &&
              gelenListe.length > 0 &&
              gelenListe.map((veriler, index) => {
                return (
                  <div key={index + 1} className="col my-5 mx-2 border">
                    <h2 className="border bg-warning">
                      Ürün Adı: {veriler.urunAdi}
                    </h2>
                    <h4>Verim: {veriler.anaUrunVerim}</h4>
                    <h4>Fiyat: {veriler.anaUrunFiyat}</h4>
                    {/* <p>Yan Ürün Verimi: {veriler.yanUrunVerim}</p>
                  <p>Yan Ürün Fiyatı: {veriler.yanUrunFiyat}</p> */}
                    <h4>Yan Ürün Geliri: {veriler.yanUrunGelir}</h4>
                    <h4>
                      Toplam Gelir:
                      {parseFloat(veriler.anaUrunVerim) *
                        parseFloat(veriler.anaUrunFiyat) +
                        parseFloat(veriler.yanUrunGelir)}
                    </h4>

                    <h4>
                      Üretim Masrafı:{" "}
                      {masrafUcteBirMi
                        ? (
                            (parseFloat(veriler.anaUrunFiyat) *
                              parseFloat(veriler.anaUrunVerim) +
                              parseFloat(veriler.yanUrunGelir)) /
                            3
                          ).toFixed(2)
                        : veriler.masraf}
                    </h4>

                    <h4>
                      Net Gelir:{" "}
                      {masrafUcteBirMi
                        ? (
                            parseFloat(veriler.anaUrunFiyat) *
                              parseFloat(veriler.anaUrunVerim) +
                            parseFloat(veriler.yanUrunGelir) -
                            (parseFloat(veriler.anaUrunFiyat) *
                              parseFloat(veriler.anaUrunVerim) +
                              parseFloat(veriler.yanUrunGelir)) /
                              3
                          ).toFixed(2)
                        : parseFloat(veriler.anaUrunFiyat) *
                            parseFloat(veriler.anaUrunVerim) +
                          parseFloat(veriler.yanUrunGelir) -
                          parseFloat(veriler.masraf)}
                    </h4>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-3">
            {/* GERi Butonu */}
            <Link to="/enhdosyaincelemesi">
              <button className="btn btn-success btn-lg mt-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                  />
                </svg>{" "}
                Dosya İncelenmesi
              </button>
            </Link>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>

          <div className="col-3">
            {/* İLERİ Butonu */}
            <Link to="/enhobjektifunsurlar">
              {" "}
              <button
                className="btn btn-primary btn-lg mt-5"
                onClick={masrafDurumunaGoreDegerle}
              >
                Objektif Unsurlar
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </GlobalProvider>
  );
}
